module.exports = "<div class=\"combobox\">\n\t<select></select>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/combobox/combobox.html
// module id = WXCV
// module chunks = 12